/**
 * SLA Support coverage primitives shared between the new-project form and
 * the Migration Wizard step 3 (Petra UAT 2026-05-20 — wizard needs the
 * same options when re-migrating an existing project onto SLA Support).
 *
 * Kept as a static `as const` tuple set so call sites can rely on union
 * narrowing for `preset` and `holidayCountry`.
 */

export const COVERAGE_TIMEZONES = [
  'Europe/Prague', 'Europe/Bratislava', 'Europe/London', 'Europe/Berlin',
  'Europe/Paris', 'Europe/Madrid', 'Europe/Rome', 'Europe/Amsterdam',
  'Europe/Warsaw', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Helsinki',
  'Europe/Stockholm', 'Europe/Athens', 'Europe/Istanbul',
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Toronto', 'America/Vancouver', 'America/Mexico_City', 'America/Sao_Paulo',
  'Asia/Dubai', 'Asia/Jerusalem', 'Africa/Johannesburg', 'Africa/Cairo',
  'Asia/Kolkata', 'Asia/Singapore', 'Asia/Hong_Kong', 'Asia/Shanghai',
  'Asia/Tokyo', 'Asia/Seoul',
  'Australia/Sydney', 'Australia/Melbourne', 'Australia/Perth', 'Pacific/Auckland',
  'UTC',
] as const;

export const COVERAGE_HOLIDAY_COUNTRIES = [
  'CZ', 'SK', 'GB', 'DE', 'FR', 'ES', 'IT', 'NL', 'PL', 'AT',
  'CH', 'BE', 'IE', 'PT', 'SE', 'NO', 'DK', 'FI', 'GR',
  'US', 'CA', 'MX', 'BR', 'AR',
  'AU', 'NZ', 'JP', 'SG', 'HK', 'IN', 'AE', 'IL', 'ZA',
] as const;

export type CoveragePreset =
  | 'business_hours'
  | 'business_hours_extended'
  | 'business_24_5'
  | 'business_24_7';

export const COVERAGE_PRESET_OPTIONS: Array<{ value: CoveragePreset; label: string }> = [
  { value: 'business_hours', label: 'Business hours (Mon-Fri 9-17)' },
  { value: 'business_hours_extended', label: 'Extended business hours (Mon-Fri 8-18)' },
  { value: 'business_24_5', label: '24/5 (Mon-Fri 24h)' },
  { value: 'business_24_7', label: '24/7 (always on)' },
];

export interface CoverageEntryRow {
  tz: string;
  preset: CoveragePreset;
  holidayCountry: string;
}
